/**
 * Tab identifiers for the Agent Tools hub. Each configurable tool source gets
 * its own tab; later phases (HTTP, client-side, skills) append here, and the
 * same registry can drive the chat-scoped tool surface.
 */
export const agentToolsTabIds = [
  'builtin',
  'mcp',
  'http',
  'client-side',
  'skills',
] as const;

export type AgentToolsTabId = (typeof agentToolsTabIds)[number];

export const defaultAgentToolsTab: AgentToolsTabId = 'builtin';

export function isAgentToolsTabId(value: unknown): value is AgentToolsTabId {
  return agentToolsTabIds.includes(value as AgentToolsTabId);
}
